import { useMemo } from 'react'
import {
  generatePivotProductStrategy,
  generatePivotTagStrategy,
  generatePivotThemeStrategy,
  generateStaticStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'
import {
  pivotProductDecorator,
  pivotTagDecorator,
  pivotThemeDecorator
} from 'utils/insightModal/strategy/searchFilterComposing/decorator'
import ComparisonMode, { ComparisonModeStrings } from 'enums/ComparisonMode'
import { CrosstabWidgetsType } from '../../types'

const useSearchFilterComposingStrategy = (rowComparisonMode?: ComparisonModeStrings) =>
  useMemo(() => {
    if (!rowComparisonMode) {
      return generateStaticStrategy()
    }

    switch (rowComparisonMode) {
      case ComparisonMode.THEMES:
        return generatePivotThemeStrategy()

      case ComparisonMode.TAGS:
        return generatePivotTagStrategy()

      case ComparisonMode.DOC_HIERARCHIES:
        return generatePivotProductStrategy()

      default:
        return generateStaticStrategy()
    }
  }, [rowComparisonMode])

const useDecoratedSearchFilterComposingStrategy = (widgetSetting: CrosstabWidgetsType) => {
  const { colComparisonMode, rowComparisonMode } = widgetSetting

  const strategy = useSearchFilterComposingStrategy(rowComparisonMode)

  switch (colComparisonMode) {
    case ComparisonMode.THEMES:
      return pivotThemeDecorator(strategy)

    case ComparisonMode.TAGS:
      return pivotTagDecorator(strategy)

    case ComparisonMode.DOC_HIERARCHIES:
      return pivotProductDecorator(strategy)

    default:
      throw new Error(`Unsupported comparison mode: ${colComparisonMode}`)
  }
}

export default useDecoratedSearchFilterComposingStrategy
